// src/multiselect/src/components/common/checkbox.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Checkbox = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      fill: "none",
      height: "24",
      viewBox: "0 0 24 24",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "20", rx: "2", width: "20", x: "2", y: "2" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17.25 8.5L10.25 15.5L6.75 12.0002",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5"
          }
        )
      ]
    }
  );
};

export {
  Checkbox
};
